import { render } from "./ProductDetails.vue?vue&type=template&id=c0a98804&ts=true"
import script from "./ProductDetails.ts?vue&type=script&lang=ts&external"
export * from "./ProductDetails.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__